/* * Denne filen inneholder konfigurasjon for tabelloppsett i applikasjonen.
 * Den definerer kolonneoverskrifter, kategorier og visningsinnstillinger for tidsserier fra NVE og andre aktører.
 */

export default {
  timeSeriesHeaders: [
    {
      text: "Stasjonsnr",
      value: "stasjonNr",
      category: "General",
    },
    {
      text: "Stasjonsnavn",
      value: "stasjonNavn",
      category: "General",
    },
    {
      text: "Måleparameter",
      value: "stasjonParameter",
      category: "General",
    },
    {
      text: "Versjon",
      value: "versjon",
      category: "General",
    },
    {
      text: "Målested",
      value: "observasjonsSted",
      category: "General",
    },
    {
      text: "Stasjontype",
      value: "stasjonType",
      category: "General",
      valueMapping: [
        {
          valueFrom: null,
          valueTo: "Ikke angitt",
        },
        {
          valueFrom: "0",
          valueTo: "Ikke angitt",
        },
        {
          valueFrom: "1",
          valueTo: "Forvaltningsstasjon",
        },
        {
          valueFrom: "2",
          valueTo: "Konsesjonspålagt stasjon",
        },
        {
          valueFrom: "3",
          valueTo: "Privat, ikke pålagt",
        },
        {
          valueFrom: "4",
          valueTo: "Annen",
        },
        {
          valueFrom: "5",
          valueTo: "Fjellskred",
        },
      ],
    },
    {
      text: "Status (i drift/nedlagt)",
      value: "status",
      category: "General",
      valueMapping: [
        {
          valueFrom: "N",
          valueTo: "Nedlagt",
        },
        {
          valueFrom: "D",
          valueTo: "I drift",
        },
      ],
    },
    {
      text: "Sanntid",
      category: "General",
      value: "sanntid",
      valueMapping: [
        {
          valueFrom: "J",
          valueTo: "Ja",
        },
        {
          valueFrom: "N",
          valueTo: "Nei",
        },
      ],
    },
    {
      text: "Målestart (dato)",
      value: "dataFraDato",
      category: "General",
      type: "date",
    },
    {
      text: "Data kontrollert fra (dato)",
      value: "dt_min_start_time",
      category: "General",
      type: "date",
    },
    {
      text: "Data kontrollert til (dato)",
      value: "dt_max_end_time",
      category: "General",
      type: "date",
    },
    {
      text: "Evt. nedlagt (dato)",
      value: "dataTilDato",
      category: "General",
      type: "date",
    },
    {
      text: "Findata fra dato",
      value: "findataFraDato",
      category: "General",
      type: "date",
    },
    {
      text: "Normal årsavrenning (l/s km2)",
      value: "normalAvrenningLsKm",
      category: "General",
      show: ["Vannføring", "Vannstand"],
    },
    {
      text: "Totalt feltareal (km2)",
      value: "totalt_feltareal_km2",
      category: "General",
      type: "float",
      show: ["Vannføring", "Vannstand"],
    },
    {
      text: "Bratthet (1085-gradient, m/km)",
      value: "gradient_10_85",
      category: "General",
      type: "float",
      show: ["Vannføring", "Vannstand"],
    },
    {
      text: "Myrprosent",
      value: "andel_myrareal",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Effektiv sjøprosent",
      value: "effektiv_sjoprosent",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Jordbruksprosent",
      value: "andel_jordbruksareal",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Skogprosent",
      value: "andel_skogareal",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Innsjøprosent",
      value: "andel_innsjoareal",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Snaufjellprosent",
      value: "andel_snaufjell",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Urbantareal prosent",
      value: "andel_urbantareal",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Breprosent",
      value: "andel_breareal",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Elvegradient (m/km)",
      value: "elvegradient",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Elvelengde (km)",
      value: "elvelengde",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Elvenavnhierarki",
      value: "elvenavnHierarki",
      category: "General",
    },
    {
      text: "Elvetetthet (m/km)",
      value: "elvetetthet",
      category: "Feltegenskap",
    },
    {
      text: "Feltnr",
      value: "feltNr",
      category: "Feltegenskap",
    },
    {
      text: "Feltaksens lengde (km)",
      value: "feltaksenslengde",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Gruppe",
      value: "gruppe",
    },
    {
      text: "Vassdragsomr. nr.",
      value: "vassdragsOmradeNr",
      category: "General",
    },
    {
      text: "Vassdragsomr. navn",
      value: "vassdragsOmrNavn",
      category: "General",
    },
    {
      text: "Reguleringsgrad areal",
      value: "reguleringsgradAreal",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Reguleringsgrad mag.",
      value: "reguleringsgradMagasin",
      category: "Feltegenskap",
      type: "float",
    },
    {
      text: "Måleparameter kode",
      value: "stasjonParameterKode",
      category: "General",
    },
    {
      text: "Høyde 10 persentil (m)",
      value: "hoyde_10persentil",
      category: "Feltegenskap",
    },
    {
      text: "Høyde 20 persentil (m)",
      value: "hoyde_20persentil",
      category: "Feltegenskap",
    },
    {
      text: "Høyde 30 persentil (m)",
      value: "hoyde_30persentil",
      category: "Feltegenskap",
    },
    {
      text: "Høyde 40 persentil (m)",
      value: "hoyde_40persentil",
      category: "Feltegenskap",
    },
    {
      text: "Høyde 60 persentil (m)",
      value: "hoyde_60persentil",
      category: "Feltegenskap",
    },
    {
      text: "Høyde 70 persentil (m)",
      value: "hoyde_70persentil",
      category: "Feltegenskap",
    },
    {
      text: "Høyde 80 persentil (m)",
      value: "hoyde_80persentil",
      category: "Feltegenskap",
    },
    {
      text: "Høyde 90 persentil (m)",
      value: "hoyde_90persentil",
      category: "Feltegenskap",
    },
    {
      text: "Høyeste punkt (m)",
      value: "hoyestepunkt",
      category: "Feltegenskap",
    },
    {
      text: "Laveste punkt (m)",
      value: "laveste_punkt",
      category: "Feltegenskap",
    },
    {
      text: "Medianhøyde (m)",
      value: "hoyde_50persentil",
      category: "Feltegenskap",
    },
    {
      text: "Høyde over havet (m)",
      value: "stasjonHoyde_moh",
      category: "General",
    },
    {
      text: "Compound key 20",
      value: "compoundKey20",
      category: "General",
      hide: true,
    },
    {
      text: "ObjektID",
      value: "OBJECTID",
      category: "General",
      hide: true,
    },
  ],
  otherTimeSeriesHeaders: [
    {
      text: "Stasjon ID",
      value: "STASJONID",
      category: "General",
    },
    {
      text: "Stasjonsnavn",
      value: "STASJONSNAVN",
      category: "General",
    },
    {
      text: "Måleparameter",
      value: "PARAMETERNAVN",
      category: "General",
    },
    {
      text: "Versjon",
      value: "VERSJON",
      category: "General",
    },
    {
      text: "Leverandør",
      value: "DATA_LEVERANDOR",
      category: "General",
    },
    {
      text: "Data eier",
      value: "DATA_EIER",
      category: "General",
    },
    {
      text: "Gruppe",
      value: "GRUPPE",
      category: "General",
    },
    {
      text: "Kommentar",
      value: "KOMMENTAR",
      category: "General",
    },
    {
      text: "Metode",
      value: "METODE",
      category: "General",
    },
    {
      text: "Eklima_element",
      value: "EKLIMA_ELEMENT",
      category: "General",
    },
    {
      text: "Elvenavnhierarki",
      value: "NAVNHIERARKI",
      category: "General",
    },
    {
      text: "Regine_area",
      value: "REGINE_AREA",
      category: "General",
    },
    {
      text: "Observasjonssted",
      value: "OBSSTED",
      category: "General",
    },
    {
      text: "Dato start",
      value: "STARTET_TXT",
      category: "General",
    },
    {
      text: "Dato slutt",
      value: "AVSLUTTET_TXT",
      category: "General",
    },
    {
      text: "Måleparameterkode",
      value: "PARAMETER",
      category: "General",
    },
    {
      text: "Sanntid",
      value: "SANNTID",
      valueMapping: [
        {
          valueFrom: "Y",
          valueTo: "Ja",
        },
        {
          valueFrom: "N",
          valueTo: "Nei",
        },
      ],
      category: "General",
    },
    {
      text: "Stasjontype",
      value: "STASJONTYPE",
      category: "General",
    },
    {
      text: "Status",
      value: "STATUS",
      valueMapping: [
        {
          valueFrom: "0",
          valueTo: "Nedlagt",
        },
        {
          valueFrom: "1",
          valueTo: "I drift",
        },
      ],
      category: "General",
    },
    {
      text: "Tidoffset",
      value: "TIDSOFFSET",
      category: "General",
    },
    {
      text: "Tidoffset_min",
      value: "TIDSOFFSET_MIN",
      category: "General",
    },
    {
      text: "Tidsoppløsning",
      value: "TIDSOPPLOSNING",
      category: "General",
    },
    {
      text: "Tidsoppløsning_min",
      value: "TIDSOPPLOSNING_MIN",
      category: "General",
    },
    {
      text: "Vassdragsnr.",
      value: "VASSDRAGSNR",
      category: "General",
    },
    {
      text: "compoundKey20",
      value: "compound_key_20",
      category: "General",
    },
  ],
  selectedColumns: [
    {
      text: "Stasjonsnr",
      value: "stasjonNr",
      category: "General",
    },
    {
      text: "Stasjonsnavn",
      value: "stasjonNavn",
      category: "General",
    },
    {
      text: "Måleparameter",
      value: "stasjonParameter",
      category: "General",
    },
    {
      text: "Versjon",
      value: "versjon",
      category: "General",
    },
    {
      text: "Målested",
      value: "observasjonsSted",
      category: "General",
    },
  ],
  selectedColumnsOtherActors: [
    {
      text: "Stasjon ID",
      value: "STASJONID",
      category: "General",
    },
    {
      text: "Stasjonsnavn",
      value: "STASJONSNAVN",
      category: "General",
    },
    {
      text: "Måleparameter",
      value: "PARAMETERNAVN",
      category: "General",
    },
    {
      text: "Versjon",
      value: "VERSJON",
      category: "General",
    },
    {
      text: "Dato start",
      value: "STARTET_TXT",
      category: "General",
    },
    {
      text: "Dato slutt",
      value: "AVSLUTTET_TXT",
      category: "General",
    },
    {
      text: "Leverandør",
      value: "DATA_LEVERANDOR",
      category: "General",
    },
  ],
};
